import './EvacuatedStatistic.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useRef } from "react";

import { fetchEvacuated } from "../../slices/statisticSlice";

import { Box } from "@mui/material";

import ReactECharts from "echarts-for-react";

const EvacuatedStatistic = ({params}) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const evacuatedStatistic = useSelector((state) => state.statistic.evacuatedStatistic);
    const chartRef = useRef(null);

    useEffect(() => {
        dispatch(fetchEvacuated({token, params}));
    }, [dispatch, token, params]);

    useEffect(() => {
        setTimeout(() => {
            chartRef.current?.getEchartsInstance().resize();
        }, 100);
    }, [evacuatedStatistic]);

    const options = {
        title: {
            text: 'Статистика эвакуации',
            left: 'center'
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' }
        },
        xAxis: {
            type: 'category',
            data: ['Эвакуированные люди', 'Медицинская помощь'],
        },
        yAxis: {
            type: 'value',
            name: 'Количество'
        },
        series: [
            {
                type: 'bar',
                data: [evacuatedStatistic.evacuated_people_total, evacuatedStatistic.provided_medical_total],
                itemStyle: { color: '#4CAF50' }
            }
        ]
    };

    return (
        <Box className="evacuated_statistic">
            <ReactECharts ref={chartRef} option={options} style={{ width: '100%', height: '100%' }} />
        </Box>
    );
};

export default EvacuatedStatistic;
